import { oneMonthBookingHorizonEnd } from '../../utils/bookingHorizon';

const LAST_TEACHER_KEY = 'speakable:landing:last-spotlight-teacher';
const MINIMUM_LEAD_TIME_MS = 24 * 60 * 60 * 1000;

export const getPublicAvailabilityPreview = (teacher, now = Date.now()) => {
  const summary = teacher?.availabilitySummary;
  if (!(summary?.availableCount > 0)) return [];
  const latestStart = new Date(oneMonthBookingHorizonEnd(now)).getTime();
  const candidates = [summary.nextAvailableAt, ...(Array.isArray(summary.nextAvailableSlots) ? summary.nextAvailableSlots : [])];
  const starts = candidates
    .filter((value) => typeof value === 'string' && value.trim())
    .map((value) => new Date(value).getTime())
    .filter((start) => Number.isFinite(start) && start >= now + MINIMUM_LEAD_TIME_MS && start <= latestStart);
  return [...new Set(starts)].sort((left, right) => left - right).slice(0, 3).map((start) => new Date(start));
};

// Persist only after the complete catalogue has loaded. Storage is optional:
// private browsing/security restrictions must never prevent showing a teacher.
export const chooseTeacherSpotlight = (teachers, currentTeacherId = null, now = Date.now()) => {
  const eligible = [...new Map(teachers
    .filter((teacher) => getPublicAvailabilityPreview(teacher, now).length)
    .map((teacher) => [String(teacher._id), teacher])).values()];
  const current = eligible.find((teacher) => String(teacher._id) === currentTeacherId);
  if (current) return current;
  if (!eligible.length) return null;

  let previousTeacherId;
  try { previousTeacherId = window.sessionStorage.getItem(LAST_TEACHER_KEY); } catch (_error) { /* Optional visit history. */ }
  const alternatives = eligible.filter((teacher) => String(teacher._id) !== previousTeacherId);
  const pool = alternatives.length ? alternatives : eligible;
  const teacher = pool[Math.floor(Math.random() * pool.length)];
  try { window.sessionStorage.setItem(LAST_TEACHER_KEY, String(teacher._id)); } catch (_error) { /* Optional visit history. */ }
  return teacher;
};

export const getSpotlightTimezone = () => {
  try { return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC'; } catch (_error) { return 'UTC'; }
};

export const buildTeacherTrialPath = (teacherId, start = null, timezone = getSpotlightTimezone()) => {
  const id = typeof teacherId === 'string' || typeof teacherId === 'number' ? String(teacherId).trim() : '';
  if (!id) return '/lekcja-probna';
  const query = new URLSearchParams({ teacher: id, book: '1', tz: timezone });
  const date = start ? new Date(start) : null;
  if (date && Number.isFinite(date.getTime())) {
    const parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: timezone, year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hourCycle: 'h23',
    }).formatToParts(date);
    const values = Object.fromEntries(parts.map(({ type, value }) => [type, value]));
    query.set('start', date.toISOString());
    query.set('date', `${values.year}-${values.month}-${values.day}`);
    query.set('time', `${values.hour}:${values.minute}`);
  }
  return `/lekcja-probna?${query.toString()}`;
};
